import { type ProductForHotelFilters } from '@ve/components/hotel/filters/common/store/types';
import { OperatorId } from '@entities/operator';
import { type ITourProduct } from '@entities/tourProduct';

export const BONUS_MILES_OPERATORS = new Set(OperatorId.Travelata);

export const BONUS_MILES_TEXT = 'Начисление миль';

export const BONUS_MILES_INFO = {
    description: 'При покупке тура для участников бонусных программ авиакомпаний возможно начисление миль.',
    availability: 'Данная опция доступна только при выборе туроператора Travelata.',
};

export const filterByBonusMiles = (tourProduct: ITourProduct | ProductForHotelFilters): boolean =>
    !!tourProduct?.operator && BONUS_MILES_OPERATORS.has(tourProduct.operator?.id);

export const hasNonBonusMilesOperators = (selectedOperators?: number[]): boolean => {
    if (!selectedOperators || selectedOperators.length === 0) {
        return false;
    }
    return selectedOperators.some((operatorId) => !BONUS_MILES_OPERATORS.has(operatorId));
};
